/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

import {UNION_R_API} from './constants'
import {normalizeRewardRecords, normalizeUnionRTaskPage} from './mapApi'
import type {
  RewardRecordsResponse,
  UnionRoomRState,
  UnionRTaskPage,
} from './types'

type ApiEnvelope<T> = {
  ret: number
  data: T
}

const emptyTaskPage: UnionRTaskPage = {
  empty: false,
  pearl_max_display: 0,
  total_pearl: 0,
  r_list: [],
  err_msg: '',
}

const emptyRewardRecords: RewardRecordsResponse = {
  list: [],
  has_more: false,
  err_msg: '',
}

const initialState: UnionRoomRState = {
  taskPage: emptyTaskPage,
  rewardRecords: emptyRewardRecords,
}

export type GetUnionRTaskPageParams = {
  room_id: number
}

export const getUnionRTaskPage = createAsyncThunk(
  'UnionRoomR/getUnionRTaskPage',
  async (arg: GetUnionRTaskPageParams, store: any) => {
    const resp = await http.post<ApiEnvelope<UnionRTaskPage>>(
      UNION_R_API.taskPage,
      {
        ...store.getState().env.deviceinfo,
        room_id: arg.room_id,
      },
      {store, xcErrorToast: true}
    )
    return normalizeUnionRTaskPage(resp?.data?.data)
  }
)

export type GetUnionRRewardRecordsParams = {
  room_id: number
}

export const getUnionRRewardRecords = createAsyncThunk(
  'UnionRoomR/getUnionRRewardRecords',
  async (arg: GetUnionRRewardRecordsParams, store: any) => {
    const resp = await http.post<ApiEnvelope<RewardRecordsResponse>>(
      UNION_R_API.rewardRecords,
      {
        ...store.getState().env.deviceinfo,
        room_id: arg.room_id,
      },
      {store, xcErrorToast: true}
    )
    return normalizeRewardRecords(resp?.data?.data)
  }
)

const UnionRoomRSlice = createSlice({
  name: 'UnionRoomR',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnionRTaskPage.fulfilled, (state, action) => {
      state.taskPage = action.payload
    })
    builder.addCase(getUnionRRewardRecords.fulfilled, (state, action) => {
      state.rewardRecords = action.payload
    })
  },
})

export default UnionRoomRSlice.reducer

export const useUnionRoomRState = (): UnionRoomRState =>
  useSelector((state: any) => state.UnionRoomR as UnionRoomRState) ??
  initialState
